// extracted by mini-css-extract-plugin
export default {"heading":"BiddingStrategy_heading__mCrNu","wrapper":"BiddingStrategy_wrapper__5J-Dq","bidStrategyContainer":"BiddingStrategy_bidStrategyContainer__-kkZ5"};